import { render, staticRenderFns } from "./MetricCategoryView.vue?vue&type=template&id=52d253a0"
import script from "./MetricCategoryView.vue?vue&type=script&lang=js"
export * from "./MetricCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports